// extracted by mini-css-extract-plugin
export default {"actions":"yitCqPmfuvPvP5XNDHUO"};